/**
 * Admin API for course types (list and update display name / sort order).
 * Requires SYSTEM_ADMIN. Use studentApi so the same JWT is sent.
 */
import studentApi from './studentApi';

const BASE = '/api/admin/course-types/records';

export interface CourseTypeDTO {
  code: string;
  displayName: string;
  sortOrder: number;
}

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export async function listCourseTypes(): Promise<CourseTypeDTO[]> {
  const res = await studentApi.get<ApiResponse<CourseTypeDTO[]>>(BASE);
  if (!res.data?.success || !res.data?.data) throw new Error(res.data?.message ?? 'Failed to load');
  return res.data.data;
}

export async function updateCourseType(
  code: string,
  payload: { displayName?: string; sortOrder?: number }
): Promise<CourseTypeDTO> {
  const res = await studentApi.put<ApiResponse<CourseTypeDTO>>(`${BASE}/${encodeURIComponent(code)}`, payload);
  if (!res.data?.success || !res.data?.data) throw new Error(res.data?.message ?? 'Failed to update');
  return res.data.data;
}
